export const shareTypes = {
  WHTS: "Whatsapp",
  MAIL: "Mail",
};
